import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function ReportLanding() {
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(49.90);
  const [fullPrice, setFullPrice] = useState(197);

  // 49,90 -> "49,90" | 197 -> "197"
  const fmt = (n) => (Number(n) % 1 === 0 ? String(Number(n)) : Number(n).toFixed(2).replace('.', ','));

  // Il prezzo lo detta il server (REPORT_PRICE nel .env del backend)
  useEffect(() => {
    axios.get('/api/pricing')
      .then((res) => {
        if (res.data && res.data.price) {
          setPrice(res.data.price);
          if (res.data.fullPrice) setFullPrice(res.data.fullPrice);
        }
      })
      .catch(() => {});
  }, []);

  const handleCheckout = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const res = await axios.post('/api/create-checkout-session', {
        amount: price,
        type: 'report'
      });
      if (res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.error('Errore checkout:', err);
      alert('Errore durante il pagamento. Riprova tra qualche istante.');
    } finally {
      setLoading(false);
    }
  };

  const isPromo = price < fullPrice;

  return (
    <div className="fade-in">
      {/* Hero */}
      <section className="landing-hero" style={{ padding: '80px 0', background: 'linear-gradient(135deg, #1a56db 0%, #0f3a8e 50%, #16a34a 100%)' }}>
        <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', padding: '6px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600, color: 'white', marginBottom: 20 }}>
            Report Personalizzato con IA
          </div>
          <h1 style={{ fontSize: 42, fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 20, maxWidth: 800, margin: '0 auto 20px' }}>
            Scopri Tutti gli Incentivi<br />
            <span style={{ color: '#86efac' }}>Compatibili con la Tua Azienda</span>
          </h1>
          <p style={{ fontSize: 19, color: 'rgba(255,255,255,0.9)', maxWidth: 650, margin: '0 auto 32px', lineHeight: 1.7 }}>
            Il nostro sistema di Intelligenza Artificiale analizza il profilo della tua azienda e genera un report dettagliato con tutti gli incentivi, bandi e agevolazioni a cui hai diritto.
          </p>
          <button onClick={handleCheckout} disabled={loading} className="btn btn-lg btn-green" style={{ fontSize: 18, padding: '18px 48px', cursor: loading ? 'wait' : 'pointer', border: 'none' }}>
            {loading ? 'Caricamento...' : `Acquista il Report — €${fmt(price)}`}
          </button>
          {isPromo && (
            <p style={{ fontSize: 14, color: '#86efac', marginTop: 8, fontWeight: 700 }}>
              Offerta Speciale! Prezzo originale: <span style={{ textDecoration: 'line-through' }}>€{fmt(fullPrice)}</span> — Risparmi €{(fullPrice - price).toFixed(0)}
            </p>
          )}
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', marginTop: 12 }}>
            Pagamento sicuro con Stripe. Dopo il pagamento riceverai l'accesso al report personalizzato.
          </p>
        </div>
      </section>

      {/* Cosa Include */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Cosa Include il Report</h2>
          <p className="section-subtitle">Un documento completo e personalizzato per la tua azienda</p>
          <div className="grid-3">
            {[
              {
                icon: '🔎',
                title: 'Analisi Completa',
                items: ['Matching con 75+ incentivi attivi', 'Compatibilità calcolata con IA', 'Filtro per settore, regione e dimensione', 'Aggiornato alle ultime normative']
              },
              {
                icon: '📋',
                title: 'Dettagli per Ogni Incentivo',
                items: ['Importi massimi ottenibili', 'Requisiti specifici', 'Scadenze e tempistiche', 'Link alle fonti ufficiali']
              },
              {
                icon: '📄',
                title: 'Istruzioni Operative',
                items: ['Guida passo-passo per ogni bando', 'Documentazione necessaria', 'Enti erogatori e contatti', 'Priorità di presentazione']
              }
            ].map((service, i) => (
              <div key={i} className="card" style={{ textAlign: 'center', padding: 32 }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>{service.icon}</div>
                <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16, color: '#111827' }}>{service.title}</h3>
                <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left' }}>
                  {service.items.map((item, j) => (
                    <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, fontSize: 14, color: '#4b5563' }}>
                      <span style={{ color: '#16a34a', fontWeight: 700 }}>&#10003;</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Confronto Preanalisi vs Report */}
      <section className="section" style={{ background: '#f8fafc' }}>
        <div className="container" style={{ maxWidth: 800 }}>
          <h2 className="section-title">Preanalisi Gratuita vs Report Completo</h2>
          <div style={{ overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              <thead>
                <tr style={{ background: '#1a56db', color: 'white' }}>
                  <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: 15 }}>Funzionalità</th>
                  <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: 15 }}>Preanalisi Gratis</th>
                  <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: 15, background: '#16a34a' }}>Report €{fmt(price)}</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Matching incentivi compatibili', true, true],
                  ['Anteprima compatibilità', true, true],
                  ['Analisi IA della visura', true, true],
                  ['Dettagli completi per ogni incentivo', false, true],
                  ['Importi massimi ottenibili', false, true],
                  ['Scadenze e requisiti specifici', false, true],
                  ['Istruzioni passo-passo', false, true],
                  ['Link fonti ufficiali', false, true],
                  ['Report PDF scaricabile', false, true],
                ].map((row, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '14px 20px', fontSize: 14, color: '#374151' }}>{row[0]}</td>
                    <td style={{ padding: '14px 20px', textAlign: 'center', fontSize: 18 }}>{row[1] ? '✅' : '❌'}</td>
                    <td style={{ padding: '14px 20px', textAlign: 'center', fontSize: 18, background: '#f0fdf4' }}>{row[2] ? '✅' : '❌'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Pricing CTA */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #1a56db 0%, #0f3a8e 100%)', color: 'white' }}>
        <div className="container" style={{ textAlign: 'center', maxWidth: 600 }}>
          <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 16 }}>
            {isPromo ? `Offerta Speciale: €${fmt(price)} invece di €${fmt(fullPrice)}` : `Investi €${fmt(fullPrice)}, Scopri Migliaia di Euro`}
          </h2>
          <p style={{ fontSize: 17, opacity: 0.9, lineHeight: 1.8, marginBottom: 32 }}>
            Un singolo incentivo può valere da €5.000 a €200.000. Il report ti mostra esattamente quali sono quelli compatibili con la tua azienda e come richiederli.
          </p>
          <div style={{
            background: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(10px)',
            borderRadius: 16, padding: 40, border: '2px solid #86efac', marginBottom: 32
          }}>
            <div style={{ fontSize: 14, fontWeight: 600, opacity: 0.8, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Report Personalizzato</div>
            {isPromo ? (
              <>
                <div style={{ fontSize: 24, fontWeight: 600, textDecoration: 'line-through', opacity: 0.6, marginBottom: 4 }}>€{fmt(fullPrice)}</div>
                <div style={{ fontSize: 56, fontWeight: 800, marginBottom: 4, color: '#86efac' }}>€{fmt(price)}</div>
                <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8, color: '#fbbf24' }}>Risparmi €{(fullPrice - price).toFixed(0)} — Offerta a tempo limitato!</div>
              </>
            ) : (
              <div style={{ fontSize: 56, fontWeight: 800, marginBottom: 8 }}>€{fmt(fullPrice)}</div>
            )}
            <div style={{ fontSize: 14, opacity: 0.8, marginBottom: 24 }}>Pagamento unico — accesso immediato</div>
            <button onClick={handleCheckout} disabled={loading} className="btn btn-lg btn-green" style={{ fontSize: 18, padding: '18px 48px', width: '100%', justifyContent: 'center', cursor: loading ? 'wait' : 'pointer', border: 'none' }}>
              {loading ? 'Caricamento...' : `Paga Ora — €${fmt(price)}`}
            </button>
            <p style={{ fontSize: 13, opacity: 0.7, marginTop: 12 }}>Pagamento sicuro con Stripe. Dopo il pagamento ti registrerai per ricevere il report.</p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 800 }}>75+</div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>Incentivi Analizzati</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 800 }}>100%</div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>Personalizzato</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 800 }}>24h</div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>Consegna Rapida</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonianze */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Cosa Dicono i Nostri Clienti</h2>
          <div className="grid-3">
            {[
              { quote: 'Il report mi ha fatto scoprire 3 bandi a cui non sapevo di avere diritto. Uno da solo vale oltre €40.000 di contributo a fondo perduto.', author: 'Marco B.', role: 'Titolare PMI — Sicilia' },
              { quote: 'Investimento migliore dell\'anno. In 24 ore avevo un quadro completo di tutti gli incentivi per la mia startup. Chiaro, dettagliato e con le istruzioni per procedere.', author: 'Francesca L.', role: 'CEO Startup — Milano' },
              { quote: 'Pensavo di non avere diritto a nulla. Il report ha trovato 8 incentivi compatibili con la mia attività artigianale. Sto già presentando le domande.', author: 'Antonio D.', role: 'Artigiano — Veneto' }
            ].map((t, i) => (
              <div key={i} className="testimonial">
                <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
                <div className="quote">"{t.quote}"</div>
                <div className="author">{t.author}</div>
                <div className="role">{t.role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section" style={{ background: '#f8fafc' }}>
        <div className="container" style={{ maxWidth: 700 }}>
          <h2 className="section-title">Domande Frequenti</h2>
          {[
            { q: 'Come funziona il pagamento?', a: 'Il pagamento avviene in modo sicuro tramite Stripe. Dopo il pagamento riceverai un\'email con le istruzioni per registrarti e accedere al tuo report personalizzato.' },
            { q: 'Quanto tempo ci vuole per ricevere il report?', a: 'Il report viene generato automaticamente dalla nostra IA dopo la registrazione. In genere è disponibile entro pochi minuti dal completamento del profilo aziendale.' },
            { q: 'Il report è personalizzato per la mia azienda?', a: 'Sì, al 100%. L\'IA analizza il tuo settore, la tua regione, la dimensione aziendale e il codice ATECO per trovare solo gli incentivi effettivamente compatibili.' },
            { q: 'Posso avere un rimborso?', a: 'Se il report non contiene almeno 3 incentivi compatibili con la tua azienda, ti rimborsiamo l\'intero importo. Nessun rischio per te.' },
            { q: 'Dopo il report, posso avere assistenza per presentare le domande?', a: 'Certamente! Offriamo il servizio di Gestione Bandi (€1.000 + 5% sul deliberato) dove il nostro team si occupa di tutta la burocrazia per te.' }
          ].map((faq, i) => (
            <div key={i} className="card" style={{ marginBottom: 12, padding: '20px 24px' }}>
              <h4 style={{ fontSize: 15, fontWeight: 700, color: '#111827', marginBottom: 8 }}>{faq.q}</h4>
              <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, margin: 0 }}>{faq.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Finale */}
      <section className="section" style={{ background: '#f0fdf4', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: 600 }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16, color: '#111827' }}>Non Perdere Neanche un Euro di Incentivi</h2>
          <p style={{ fontSize: 16, color: '#4b5563', lineHeight: 1.8, marginBottom: 24 }}>
            Ogni giorno che passa, bandi e scadenze si avvicinano. Scopri subito a cosa hai diritto.
          </p>
          <button onClick={handleCheckout} disabled={loading} className="btn btn-lg btn-green" style={{ fontSize: 18, padding: '18px 48px', cursor: loading ? 'wait' : 'pointer', border: 'none' }}>
            {loading ? 'Caricamento...' : `Acquista il Report — €${fmt(price)}`}
          </button>
          <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 16 }}>
            Consulentecrediti S.r.l.s. — P.IVA 06139990870 — Pagamento sicuro con Stripe
          </p>
        </div>
      </section>
    </div>
  );
}
